import { Injectable } from '@angular/core';
import { PersistenceService } from 'angular-persistence';
import { MessageService } from 'primeng/primeng';
import { GeneralService } from './general.service';
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TingeeService extends GeneralService {

  constructor(
    protected messageService: MessageService,
    protected httpClient: HttpClient,
    protected persistenceService: PersistenceService,
  ) {
    super(
      messageService,
      httpClient,
      persistenceService,
      environment.apiPostUrl,
      "Tingee"
    );
  }

  async checkTransaction(qrAccount: string, billId: string): Promise<any> {
    let params = new HttpParams();
    params = params.append("qrAccount", qrAccount);
    params = params.append("billId", billId);
    const res = await this.getCustomApi("CheckTransaction", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }
}
